import styled from 'styled-components';
import colors from 'Styles/colors';
import { FaChevronDown } from 'react-icons/fa';
import { Title } from '../styled';
import { ellipsisText } from 'Styles/styles';
import { ReactComponent as TrashIcon } from 'Images/icon-action-bar-trash.svg';

export const Wrapper = styled.div`
`;
Wrapper.displayName = 'Wrapper';

export const InputWrapper = styled.div`
  height: 34px;
  position: relative;
`;

export const StyledTitle = styled(Title)`
  color: ${({ theme }) => theme.text.modalLabel} !important;
  ${({ required }) => required && `
    position: relative;
    &:after {
      content: '*';
      color: ${colors.redPink}; 
      position: absolute;
      margin-left: 3px;
    }
  `}  
`;
StyledTitle.displayName = 'StyledTitle';

export const InputComp = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  border-left: 12px solid ${colors.softBlue};
  background-color: ${({ theme }) => theme.textfield.background};
  padding-left: 15px;
  padding-right: 42px;
  font-weight: 300 !important;
  margin-bottom: 2px;
  font-size: 14.5px;
  color: ${({ theme }) => theme.textfield.text};
  box-shadow: ${({ theme }) => theme.shadows.inputs};

  &.full{
    background-color: ${({ theme }) => theme.backgrounds.inputsFocus}; 
  }

  &.responsive {
    width: 100%;
  }

  &::placeholder {
    color: ${({ theme }) => theme.text.placeholder};
    font-size: 13.5px;
    font-weight: 300;
  }

  &:hover{
    border-style: solid;
    border-color: ${({ theme }) => theme.shadows.inputInset};
    border-width: 1px 1px 1px 1px; 
    border-left: 12px solid ${colors.softBlue};
  }

  &:focus{
    background-color: ${({ theme }) => theme.backgrounds.inputsFocus};

    &::placeholder {
      color: transparent;
    }
  }

  ${({ disabled }) => disabled && 'cursor: not-allowed'};
`;
InputComp.displayName = 'InputComp';

export const ChevronDown = styled(FaChevronDown)`
  position: absolute;
  right: 14px;
  top: 14px;
  cursor: pointer;
  color: #515a65;
  font-size: 11px;
`;
ChevronDown.disabled = 'ChevronDown';

export const ListData = styled.div`
  background: ${({ showGradient, theme }) =>
        showGradient
            ? `linear-gradient(
                to bottom,
                ${theme.backgrounds.modal} 0%,       
                ${theme.backgrounds.modal} 33.33%,  
                ${theme.backgrounds.modal4} 33.33%,   
                ${theme.backgrounds.modal4} 66.66%,   
                ${theme.backgrounds.modal} 66.66%,  
                ${theme.backgrounds.modal} 100%
            )`
            : theme.backgrounds.modal};
  box-shadow: ${({ theme }) => theme.shadows.standardDropdown};
  overflow-y: auto;
  min-height: 110px;
  max-height: 110px;
  margin-top: 5px;
`;
ListData.displayName = 'ListData';

export const DataItem = styled.div`    
  cursor: pointer;
  padding: 0 14px;
  height: 36.6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => (props.isOdd ? props.theme.backgrounds.modal4 : props.theme.backgrounds.modal)};
  &:hover {
      background-color: ${({ theme }) => theme.selector.selected};
    }
`;
DataItem.displayName = 'DataItem';

export const DataItemWrapper = styled.div`
  display: flex;
  width: 100%;
`;
DataItemWrapper.displayName = 'DataItemWrapper';

export const Placeholder = styled.p`
  text-align: left;
  font-size: 13.5px;
  line-height: 2.52;
  margin-right: auto;
  color: ${({ theme }) => theme.selector.text};
  ${ellipsisText}
`;
Placeholder.displayName = 'Placeholder';

export const Text = styled(Placeholder)`
  width: 90px;
`;
Text.displayName = 'Text';

export const TrashWrapper = styled.div`
  margin-left: auto;
  padding-left: 20px;
`;
TrashWrapper.displayName = 'TrashWrapper';

export const Trash = styled(TrashIcon)` 
  width: 16px;
  height: 17px;
  align-self: flex-end;
  g > path { 
    fill: #dc4a4a;
  }

`;
Trash.displayName = 'Trash';
